import './ProgressBar.scss';

const ProgressBar = ({ progress, showText = true }) => {
    return (
        <div className="progress-bar">
            <div 
                className="progress-bar__fill"
                style={{ width: `${progress}%` }}
            />
            {showText && (
                <span className="progress-bar__text">
                    {progress}%
                </span>
            )}
        </div>
    );
};

export default ProgressBar;